import React from 'react';

export function websiteHref(domainOrUrl) {
  if (!domainOrUrl) return null;
  const value = String(domainOrUrl).trim();
  if (!value) return null;
  if (/^https?:\/\//i.test(value)) return value;
  return `https://${value.replace(/^\/+/, '')}`;
}

function ExternalLink({ href, children, className = '' }) {
  const url = websiteHref(href);
  if (!url) {
    return <span className={className}>{children}</span>;
  }
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className={`text-ink-muted hover:text-link hover:underline ${className}`}
      onClick={(e) => e.stopPropagation()}
    >
      {children}
    </a>
  );
}

export default ExternalLink;
